import React, { useState, useEffect, FC, ReactNode } from 'react';
import { IEventsService, Localization } from 'shared/types';

import { useLogger } from '../logger';
import { LocalizationContext } from './LocalizationContext';

interface Props {
    localizationService: Localization<any>;
    eventsService: IEventsService;
    children: ReactNode;
}

export const LocalizationContextProvider: FC<Props> = ({
    localizationService,
    eventsService,
    children,
}) => {
    const [language, setLanguage] = useState<string>(localizationService.getCurrentLanguage());
    const { logger } = useLogger();

    useEffect(() => {
        const updateLanguage = () => {
            const newLanguage = localizationService.getCurrentLanguage();
            setLanguage(newLanguage);
            logger.log('language changed', newLanguage);
        };

        updateLanguage();

        eventsService.on('locale:changed', updateLanguage);
        logger.log('add language change listener');

        return () => {
            eventsService.off('locale:changed', updateLanguage);
            logger.log('remove language change listener');
        };
    }, []);

    return (
        <LocalizationContext.Provider value={{ localizationService, language }}>
            {children}
        </LocalizationContext.Provider>
    );
};
